module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_content-4228a15fc383b4328b96e7626778cf82.jpg";